function StyledButton({ children, onClick, type = "button" }) {
    return (
        <button
            type={type}
            onClick={onClick}
            style={{
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: 'bold',
                backgroundColor: '#F4A261',
                color: '#5E503F',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '10px'
            }}
        >
        {children}
        </button>
    );
}

export default StyledButton;